<mat-sidenav-container class="va-nav" [ngClass]="{ 'va-nav-hidden': hideSideBar }" [hasBackdrop]="false">
  <mat-sidenav
    class="va-nav-sidebar"
    #sidenav
    mode="over"
    role="navigation"
    fixedInViewport
    [opened]="opened"
    (opened)="onOpen()"
    (closed)="onClose()"
    [fixedTopGap]="fixedTopGap"
    [disableClose]="disableClose"
  >
    <ng-content select="[nav-scrolless-header]" />
    <div class="scrollable">
      <ng-content select="[nav-header]" />
      <ng-content select="[nav-items]" />
    </div>
    <div class="nav-footer">
      <ng-content select="[nav-footer]" />
    </div>
  </mat-sidenav>
  <ng-content select="main" />
</mat-sidenav-container>
